import { render, staticRenderFns } from "./ProfileEa.vue?vue&type=template&id=c03e067c&lang=pug&"
import script from "./ProfileEa.vue?vue&type=script&lang=ts&"
export * from "./ProfileEa.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileEa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VImg,VSimpleTable})
